const MainLayout = ({ children }) => {
  return (
    <div className="shadow-custom-soft p-2 rounded-2xl bg-background text-darkText h-full w-full bg-white">
      {children}
    </div>
  );
};

export default MainLayout;
